/* ez-sticky-atc.js — the sticky ATC bar is DRIVEN by ez-pdp-buy-hero.js, which owns the buy state
   (variant, add-ons, total, gated?) and claims a bar by matching [data-atc-for] to its own
   data-section-id. This file only exists to (a) guarantee the bar starts hidden even if the buy
   hero JS is slow/absent, and (b) claim any ORPHAN bar (a bar whose buy hero never initialised) so
   it degrades to a plain scroll-to-top + native form submit rather than sitting dead on screen.
   Kept tiny on purpose — no duplicate add logic. */
(function () {
  function orphanGuard() {
    document.querySelectorAll('[data-ez-atc-bar]').forEach(function (bar) {
      if (bar.dataset.ezAtcClaimed === '1') return;
      // give the buy hero a beat to claim it; if unclaimed, wire a minimal fallback
      var forId = bar.getAttribute('data-atc-for');
      var host = forId ? document.querySelector('[data-section-id="' + forId + '"]') : null;
      var btn = bar.querySelector('[data-ez-atc-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (bar.dataset.ezAtcClaimed === '1') return; // buy hero took over in the meantime
        var form = host && host.querySelector('form[action*="/cart/add"], #ez-pdp-form');
        if (form && form.requestSubmit) { form.requestSubmit(); return; }
        if (form) { form.submit(); return; }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(orphanGuard, 600); });
  } else {
    setTimeout(orphanGuard, 600);
  }
})();
